function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import CustomPopover from "@com/components/custom-popover/index.vue";
import { computed, defineComponent } from "vue";
import { filterSchemaConfig } from "@pt/views/pt-entry/components/filter-bar/filter-model";
import i18n from "@/lang";
import { language } from "@/common/storage";
export default defineComponent({
    components: {
        CustomPopover: CustomPopover
    },
    props: {
        model: Object
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var label = i18n.t("resourceManager.filter.size");
        var popoverSchema = [
            [
                {
                    label: i18n.t("resourceManager.filter.width")
                },
                filterSchemaConfig.width_min,
                {
                    label: "-"
                },
                filterSchemaConfig.width_max, 
            ],
            [
                {
                    label: i18n.t("resourceManager.filter.high")
                },
                filterSchemaConfig.height_min,
                {
                    label: "-"
                },
                filterSchemaConfig.height_max, 
            ], 
        ];
        // const durationPopoverConfig = {
        //   width: 245,
        // }
        var durationPopoverConfig = computed(function() {
            return {
                width: language.get() === "en" ? 255 : 235
            };
        });
        var durationSelectedValue = computed(function() {
            var widthMin = props.model.width_min;
            var widthMax = props.model.width_max;
            var heightMin = props.model.height_min;
            var heightMax = props.model.height_max;
            var widthValue = "";
            var heightValue = "";
            var value = [];
            if (widthMin || widthMax) {
                if (widthMin) {
                    widthValue = "".concat(widthMin, "px\u2264") + widthValue;
                }
                widthValue += i18n.t("resourceManager.filter.widthSize");
                if (widthMax) {
                    widthValue = widthValue + "\u2264".concat(widthMax, "px");
                }
                value.push({
                    label: widthValue,
                    value: "width"
                });
            }
            if (heightMin || heightMax) {
                if (heightMin) {
                    heightValue = "".concat(heightMin, "px\u2264") + heightValue;
                }
                heightValue += i18n.t("resourceManager.filter.highSize");
                if (heightMax) {
                    heightValue = heightValue + "\u2264".concat(heightMax, "px");
                }
                value.push({
                    label: heightValue,
                    value: "height"
                });
            }
            return value;
        });
        var handleChange = function(value) {
            emit("change", value);
        };
        var clearWidthValue = [
            {
                prop: "width_min",
                value: 0
            },
            {
                prop: "width_max",
                value: 0
            }, 
        ];
        var clearHeightValue = [
            {
                prop: "height_min",
                value: 0
            },
            {
                prop: "height_max",
                value: 0
            }, 
        ];
        var deleteTag = function(tag) {
            if (tag === "width") {
                emit("change", clearWidthValue);
            } else if (tag === "height") {
                emit("change", clearHeightValue);
            }
        };
        var handleClearClick = function(event) {
            emit("change", _toConsumableArray(clearWidthValue).concat(_toConsumableArray(clearHeightValue)));
        };
        return {
            label: label,
            durationPopoverConfig: durationPopoverConfig,
            popoverSchema: popoverSchema,
            durationSelectedValue: durationSelectedValue,
            handleChange: handleChange,
            deleteTag: deleteTag,
            handleClearClick: handleClearClick
        };
    }
});
